export const CLARITY_EVENTS = {
  PAGE_VIEW: "page_view",

  START_YOUR_PROJECT: "start_your_project",

  VIEW_OUR_WORK: "view_our_work",

  VIEW_ALL_OUR_PROJECTS: "view_all_our_projects",

  SEND_MESSAGE: "send_message",

  GET_IN_TOUCH: "get_in_touch",
};